<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content"
    header-class="popup_left_header"
    body-class="c-body-no-padding container"
    :visible="visible"
    @show="onShow"
    @hide="hide"
  >
    <template #modal-header="{ close }">
      <span>{{$t('region_popup.title')}}</span>
      <b-img class="mo_close_btn"  @click="hide" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <div class="desc">
        {{$t('region_popup.desc')}}
    </div>
    <div class="wrap">      
      <div class="province">
        <div @click="onArea(item, i)" v-for="(item, i) in areaList" :class="['area', item.f_select?'area_select':'']">
          {{item.f_name}}
        </div>
      </div>
      <div class="divider"/>
      <div class="town">
        <div v-for="item in districtList" class="district">
          <span class="district_label">{{item.f_district}}</span>
          <b-button @click="onLike(item.f_idx, item.f_like)" class="district_btn" variant="white">
            <b-img v-if="item.f_like == 'Y'" :src="require('../../../assets/image/ic_heart_on@2x.png')" style="height: 1.2em;"/>
            <b-img v-else :src="require('../../../assets/image/ic_heart_off@2x.png')" style="height: 1.2em;"/>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";


export default {
  name: "RegionalSettingPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      list: [],
      areaList: [],
      districtList: [],
    }
  },
  methods:{
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },
    hide(){
      this.$emit('cancel');
      if(window.history.state == "forward")
        window.history.back();
    },
    getAreaList(){
      Utils.requestGet(
        this.$c.API.Site.getAreaList,
        {},
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          let areaList = [];
          result.data.list.forEach((it, idx) => {
            if (!areaList.some(item => {
              return item.f_name == it.f_area;
            })) {
              areaList.push({
                f_name: it.f_area,
                f_select: idx == 0,
              });
            }
          });
            this.list = result.data.list;
            this.areaList = areaList;
            this.getDistrictList(this.areaList[0].f_name);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    likeArea(area){
      let like = this.districtList.some(it => {
        return it.f_like == 'N'
      }) ? 'Y' : 'N';
      Utils.requestGet(
        this.$c.API.Site.setTotalAreaLike,
        {
          area_name: area.f_name,
          like: like
        }
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {

            this.districtList = this.districtList.map(it => {
              it.f_like = like;
              return it;
            });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onLike(idx, like_status){
      Utils.requestGet(
        this.$c.API.Site.setAreaLike,
        {
          area_idx: idx,
          like: like_status == 'Y' ? 'N' : 'Y',
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.districtList = this.districtList.map(it => {
              if (it.f_idx == idx) {
                it.f_like = like_status == 'Y' ? 'N' : 'Y';
              }
              return it;
            });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    getDistrictList(area_name){
        this.districtList = this.list.filter(it => {
          return it.f_area == area_name;
        });
    },

    onArea(item, index){
      if (item.f_select) {
        // like/unlike all
        this.likeArea(item);
      } else {
          this.areaList = this.areaList.map((it, idx) => {
            it.f_select = idx == index;
            return it;
          });
          this.getDistrictList(item.f_name);
      }
    }
  },
  computed:{
  },
  watch:{
  },
  mounted() {
    this.getAreaList();
  },
  inject: ['eventBus'],
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
.wrap{
  height: 100%;
  overflow: hidden;
  display: flex;
  border-top: solid 0.5px #eeeded;
}

.province{
  //display: flex;
  //flex-direction: column;
  //flex-wrap:wrap;
  flex: 2;
  height: 100%;
  overflow: auto;
  background-color: #f5f4f4;
}

.town{
  display: flex;
  flex-direction: column;
  flex: 3;
  height: 100%;
  overflow: auto;
}

.area_text{color: #0840ba; font-size: $fs_18; font-family: $korean_gd_14_r};

.area{
  @extend .area_text;
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 50px;
  background-color: #f5f4f4;
  align-items: center;
  justify-content: center;
  border-bottom: solid 0.5px #f5f4f4;
  padding: 25px 0px 25px;
}

.area_select{background-color: $white}

.divider{width: 2px; background-color: #f9f9f9; height: 100%};

.district_label{ text-align:left; color: $primary; font-size: $fs_18; font-family: $korean_gd_14_r};

.district{
  //@extend .district_label;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  margin-left: 14px;
  margin-right: 15px;
  border-bottom: solid 0.5px #d2d2d2;
  padding: 5px 0px 5px 24px;
};

.district_btn{width: 50px; height: 48px; align-items: center; justify-content: center};

.desc{
  color: #d21111;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;  
  text-align: right;
  padding: 10px;
}
</style>

<style lang="scss">


.title{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/RegionalSettingPopup.vue